<template>
   <woot-modal :show.sync="isOpen" :on-close="onClose" modalMainContainerClass="add_campaign_discard">
      <div>
        <div class="discard_icon">
            <div v-html="discardIcon"></div>
        </div>
        <h2 class="font_regular font_700 text_20 d_title">
          <!-- {{ $t('CAMPAIGN.ADD_STEP.DISCARD_MODAL.TITLE') }} -->
          {{title}}
        </h2>
        <p class="d_description font_regular font_500 text_14">
          <!-- {{ $t('CAMPAIGN.ADD_STEP.DISCARD_MODAL.DESCRIPTION') }} -->
          {{description}}
          </p>
        <div class="discard_btns">
            <woot-button
            color-scheme="alert"
            variant="clear"
            @click="onYes"
            >
            <!-- {{ $t('CAMPAIGN.ADD_STEP.DISCARD_MODAL.YES_BTN') }} -->
            {{yesLabel}}
            </woot-button>
            <woot-button
            variant="clear"
            color-scheme="secondary"
            @click="onClose"
            >
            {{noLabel}}
            <!-- {{ $t('CAMPAIGN.ADD_STEP.DISCARD_MODAL.NO_BTN') }} -->
            </woot-button>
        </div>
      </div>
    </woot-modal>
</template>

<script>
import {svgIcons} from "shared/components/FluentIcon/svg_icons"
export default {
    props:{
      isOpen:{
        type: Boolean,
        default: false,
      },
      title: {
        type: String,
        required: true,
      },
      description: {
        type: String,
        required: true,
      },
      yesLabel: {
        type: String,
        default: 'Yes',
      },
      noLabel: {
        type: String,
        default: 'No',
      },
    },
    data(){
      return {
         discardIcon: svgIcons.alert({height:60,width:60})
      }
    },
    methods:{
      onClose(){
        this.$emit("onClose")
      },
      onYes(){
        this.$emit("onYes")
      },
    },
}
</script>

<style lang="scss" scoped>
.discard_icon{
    width: fit-content;
    margin: 40px auto 0;
}
.d_title{
    margin-top: 24px;
    text-align: center;
}
.d_description{
    margin-top: 8px;
    text-align: center;
}

</style>

<style>
.add_campaign_discard{
    max-width: 380px;
}
.add_campaign_discard .discard_btns{
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 24px;
}
.add_campaign_discard .discard_btns button{
    font-family: 'Figtree', sans-serif;
    line-height: 1.4;
    font-weight: 600;
    font-size: 14px;
    width: 100%;
    border: 1px solid !important;
}

.add_campaign_discard .discard_btns button:nth-child(2){
    border-color: #EEEEEE !important;
    color: #858585 !important;
}
</style>